import {RecognitionType} from '../../types/recognition';
import {RecognitionCard} from "./RecognitionCard";
import {useEffect, useState} from "react";
import {getRecentShoutouts, Shoutout} from '../../services/shoutoutService';

const getMessageDescription = (sender: string, receiver: string, index: number) => {
    const templates = [
        `${sender} recently recognized ${receiver}`,
        `${sender} gave a shoutout to ${receiver}`,
        `${receiver} received a shoutout from ${sender}`,
        `${sender} celebrated ${receiver}'s contributions`,
        `Big shoutout from ${sender} to ${receiver}`,
    ];
    // picks a template based on index so each card gets a consistent message
    return templates[index % templates.length];
};

export const RecentRecognition = () => {
    const [shoutouts, setShoutouts] = useState<Shoutout[]>([]);

    const [isLoading, setLoading] = useState<boolean>(true);

    const [error, setError] = useState<string | null>(null);

    // Fetch recent recognitions on component mount
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const data = await getRecentShoutouts();
                setShoutouts(data);
            } catch (err) {
                setError("error fetching recognitions");
            } finally {
                setLoading(false);
            }
        };
        fetchdata();
    }, []);

    return (
        <section className="text-center py-7 flex flex-col items-center">
            <h2 className="text-xl font-semibold text-gray-800">Recent Recognition</h2>
            <p className="text-gray-500 mt-2">
                See how your teammates are celebrating each other
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                {isLoading && <p>Loading...</p>}
                {error && <p className="text-red-500">{error}</p>}
                {!isLoading && !error && (
                    shoutouts.map((shoutout, index) => (
                        <RecognitionCard key={index} variant={RecognitionType.ShoutOut}
                                         description={getMessageDescription(shoutout.senderName, shoutout.receiverName, index)}
                        />
                    ))
                )}
            </div>
        </section>
    )
}